<div class="container-fluid tf-form">

  <!-- ── CABECERA DE PÁGINA ── -->
  <div class="tf-page-header">
    <h4 class="tf-page-title">Factura simplificada</h4>
    <button mat-stroked-button class="btn-convfact" (click)="save(ticket)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

  <div *ngIf="ready">

    <!-- ── SECCIÓN: DATOS DEL COBRO ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>

        <div class="tf-section-header">
          <h6 class="tf-section-title">Datos del cobro</h6>
          <div class="tf-section-actions">
            <app-help key='Contactos6'></app-help>
            <button mat-stroked-button (click)="newContact(false)">
              <mat-icon>person_add</mat-icon> Nuevo contacto
            </button>
          </div>
        </div>

        <span *ngIf="(newContactLoaded | async) === null" class="text-muted d-block small mb-2">
          No se pudo actualizar el listado de contactos
        </span>

        <div class="row g-3">

          <div class="col-sm-6 col-xl-3">
            <app-autocomplete-select
              [items]="contactList" placeholder="Contacto" [idField]="'companyName'"
              [(selectedItemId)]="ticket.receiverName" [displayField]="'companyName'"
              (selectionChanged)="onSelectContact($event)" [classList]="'tf-field'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6 col-xl-3">
            <app-autocomplete-select
              [items]="billMethods" [(selectedItemId)]="ticket.typePay" [idField]="'id'"
              (selectionChanged)="onSelectTypePay($event)" [isRequired]="true" [displayField]="'data'"
              placeholder="Tipo de cobro" [classList]="'tf-field'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6 col-xl-3" *ngIf="ticket.typePay === 'Socio'">
            <app-autocomplete-select
              [items]="sociosList" [(selectedItemId)]="ticket.partnersId" [idField]="'uid'"
              [displayField]="'nameOrBusinessName'" placeholder="Socio" [classList]="'tf-field'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6 col-xl-3" *ngIf="ticket.typePay === 'Efectivo'">
            <app-autocomplete-select
              [items]="efectivoList" [(selectedItemId)]="ticket.efectivoId" [idField]="'uid'"
              [displayField]="'nombre'" placeholder="Caja / Efectivo" [classList]="'tf-field'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6 col-xl-3"
            *ngIf="ticket.typePay === 'Transferencia bancaria'
                || ticket.typePay === 'Remesa en cuenta'
                || ticket.typePay === 'Tarjeta'
                || ticket.typePay === 'Confirming'
                || ticket.typePay === 'Pagarés'">
            <app-autocomplete-select
              [items]="bankAccounts" [(selectedItemId)]="ticket.bankAccountId" [idField]="'id'"
              [displayFields]="['bank', 'iban']" placeholder="Cuenta bancaria" [classList]="'tf-field'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6 col-xl-3" *ngIf="isProjectEnable && projects?.length > 0">
            <app-autocomplete-select
              [items]="projects" [(selectedItemId)]="ticket.projectUid" [idField]="'id'"
              [displayField]="'display'" placeholder="Proyecto" [classList]="'tf-field'">
            </app-autocomplete-select>
          </div>

          <div class="col-sm-6 col-xl-3">
            <div class="tf-checkbox-field">
              <mat-checkbox name="cobrado" [(ngModel)]="paidedCheck" (change)="paided()">
                Cobrado
              </mat-checkbox>
            </div>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- ── SECCIÓN: CONCEPTOS ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>

        <div class="tf-section-header">
          <h6 class="tf-section-title">Conceptos</h6>
          <button mat-stroked-button color="primary" (click)="addInvoiceLine()">
            <mat-icon>add</mat-icon> Añadir concepto
          </button>
        </div>

        <!-- Tabla de líneas -->
        <div class="tf-lines-wrap" *ngIf="ticket.ticketLines?.length > 0">

          <!-- Cabecera (desktop) -->
          <div class="tf-line tf-line--header">
            <span>Concepto</span>
            <span>Uds.</span>
            <span>Precio</span>
            <span>Dto. %</span>
            <span>Impuestos</span>
            <span class="text-end">Total línea</span>
            <span></span>
          </div>

          <!-- Filas -->
          <div *ngFor="let item of ticket.ticketLines; index as i; trackBy: trackByIndex"
               class="tf-line tf-line--data border rounded">
            <div class="tf-cell">
              <span class="tf-cell-label">Concepto</span>
              <strong>{{ item.product }}</strong>
            </div>
            <div class="tf-cell">
              <span class="tf-cell-label">Uds.</span>
              {{ item.quantity }}
            </div>
            <div class="tf-cell">
              <span class="tf-cell-label">Precio</span>
              {{ item.unityAmount }}€
            </div>
            <div class="tf-cell">
              <span class="tf-cell-label">Dto.</span>
              {{ item.discount }}%
            </div>
            <div class="tf-cell">
              <span class="tf-cell-label">Impuestos</span>
              {{ getStrTaxes(item.taxes) }}
            </div>
            <div class="tf-cell fw-bold text-end">
              <span class="tf-cell-label">Total</span>
              {{ calcularTotalesLinea(item) }}€
            </div>
            <div class="tf-cell tf-line-actions">
              <button mat-icon-button color="primary" (click)="toggleEditMode(i)" title="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removeInvoiceLine(item)" title="Eliminar">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

        </div>

        <!-- Estado vacío -->
        <div *ngIf="!ticket.ticketLines || ticket.ticketLines.length === 0"
             class="tf-empty-state">
          <mat-icon>receipt</mat-icon>
          <p>Sin conceptos. Pulsa "Añadir concepto" para empezar.</p>
        </div>

        <!-- Barra de totales -->
        <div class="pf-section-divider mt-2"></div>
        <div class="pf-totals-bar">
          <div class="pf-totals-bar__items">
            <span class="pf-totals-bar__item">Subtotal <strong>{{ calcularSubtotal() }}€</strong></span>
            <ng-container *ngFor="let taxView of taxesToTheView; trackBy: trackByIndex">
              <span class="pf-totals-bar__sep">·</span>
              <span class="pf-totals-bar__item"><strong>{{ taxView }}</strong></span>
            </ng-container>
          </div>
          <div class="pf-totals-bar__total">
            Total <strong>{{ calcularTotal() }}€</strong>
          </div>
        </div>

      </mat-card-content>
    </mat-card>

  </div>

</div>
